import React, { createContext, useContext, useState, useCallback } from "react";
import AlertNotification from "./AlertNotification";

const AlertContext = createContext();

export function AlertProvider({ children }) {
    const [message, setMessage] = useState("");
    const [type, setType] = useState("success");
    const [recordName, setRecordName] = useState("");
    const [action, setAction] = useState("");


       const showAlert = useCallback((msg, alertType = "success", recName = "", alertAction = "") => {
        setMessage(msg);
        setType(alertType);
        setRecordName(recName);
        setAction(alertAction);
        setTimeout(() => setMessage(""), 5000);
    }, []);


    return (
        <AlertContext.Provider value={{ showAlert }}>
            {children}

            {message && (
                <AlertNotification
                    type={type}
                    recordName={recordName}
                    action="discard"
                    onClose={() => setMessage("")}
                />
            )}

        </AlertContext.Provider>
    );
}

export function useAlert() {
    return useContext(AlertContext);
}
